export default __webpack_public_path__ + "static/media/science_image.0c164619.png";